import { useState } from 'react';
import reactDom from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { login } from '../../API/User';
import { rx } from '../../Redux/Actions';
import {
  logoutRx,
  unauthRx,
  loginRx,
} from '../../Redux/Actions/UserActions/thunk';

import { handleImageError } from '../../Utils/helpers';

import profileimage from '../../Static/icons/user.svg';

import { getUserData } from '../../Redux/Selectors/UserSelectors';

import { Container } from '../UI/Containers';
import { Form } from '../UI/Form';
import { Modal } from '../UI/Modal';

import {
  StyledHeaderLine,
  StyledHeaderWrapper,
  StyledHeaderNav,
  StyledLogo,
  StyledContactsWrapper,
  StyledSocialLinks,
  StyledSocialLink,
  StyledHeaderNavRow,
  StyledHeaderNavLinksWrapper,
  StyledHeaderNavLinks,
  StyledHeaderLink,
  StyledBurger,
  StyledBurgerStick,
  StyledLogin,
} from './StyledHeader';

import { ConfirmPortal } from '../../Pages/BrokerProfilePage';
import { confirmLogoutConfigs } from '../../Configs/FormConfigs';

import logo from '../../Static/images/logo_black@1x.png';
import logoWEBP from '../../Static/images/logo_black@1x.webp';
import { ReactComponent as FbIcon } from '../../Static/icons/fb.svg';
import { ReactComponent as InstaIcon } from '../../Static/icons/insta.svg';
import { ReactComponent as TelIcon } from '../../Static/icons/tel.svg';
import { ReactComponent as UserIcon } from '../../Static/icons/user.svg';

import { constants } from '../../Configs/constants';
import { routes } from '../../Routes';
import { loginFormConfig } from '../../Configs/FormConfigs';

const {
  BASE_URL,
  urls: { CONSOLE_PROFILE, MAIN },
} = constants;

export const Socials = ({ className }) => (
  <StyledSocialLinks className={className}>
    <li>
      <StyledSocialLink href="https://facebook.com" target="_blank">
        <FbIcon className="icon" />
      </StyledSocialLink>
    </li>
    <li>
      <StyledSocialLink href="https://instagram.com" target="_blank">
        <InstaIcon className="icon" />
      </StyledSocialLink>
    </li>
  </StyledSocialLinks>
);

export const LoginPortal = ({ open, entered, fn, handleSubmit }) => {
  return open
    ? reactDom.createPortal(
        <Modal open={open} closeFn={fn}>
          <Form
            entered={entered}
            {...loginFormConfig}
            submitFn={handleSubmit}
          />
        </Modal>,
        document.getElementById('root'),
      )
    : null;
};

export const Login = ({ loginState, handleCloseBurger }) => {
  const [open, setOpen] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);
  const [entered, setEntered] = useState(false);
  const {
    user: { gravatar, name, avatarURL, tokenAccess, tokenRefresh },
  } = useSelector(getUserData);

  const dispatch = useDispatch();

  const handleClick = async () => {
    setOpen(true);
    handleCloseBurger();
    setTimeout(() => setEntered(true), 0);
  };

  const handleClickLogout = async () => {
    setOpenLogout(true);
    handleCloseBurger();
    setTimeout(() => setEntered(true), 0);
  };

  const handleClose = e => {
    if (e) {
      e.stopPropagation();
      if (e.target !== e.currentTarget) {
        return;
      }
    }
    setEntered(false);
    setTimeout(() => {
      setOpen(false);
      setOpenLogout(false);
    }, 100);
  };

  const handleSubmit = async (e, data) => {
    dispatch(rx(unauthRx, loginRx, login, data, e));
  };

  const handleLogout = async e => {
    dispatch(rx(logoutRx, tokenAccess, tokenRefresh));
    handleClose();
  };

  return (
    <StyledLogin
      onClick={loginState ? handleClickLogout : handleClick}
      className="login__button"
    >
      {loginState ? (
        <picture className="card__photo">
          {!!avatarURL && (
            <>
              <source
                srcSet={`${BASE_URL}/${avatarURL}.webp`}
                type="image/webp"
              />
              <source
                srcSet={`${BASE_URL}/${avatarURL}.png`}
                type="image/png"
              />
            </>
          )}
          <img
            src={gravatar}
            alt={name}
            onError={handleImageError(profileimage)}
            style={{ width: '40px', height: '40px', borderRadius: '50%' }}
          />
        </picture>
      ) : (
        <UserIcon />
      )}
      {loginState ? <span>Atsijungti</span> : <span>Prisijungti</span>}
      {open && (
        <LoginPortal
          fn={handleClose}
          open={open}
          entered={entered}
          handleSubmit={handleSubmit}
        />
      )}
      {openLogout && (
        <ConfirmPortal
          open={openLogout}
          entered={entered}
          fn={handleClose}
          handleSubmit={handleLogout}
          config={confirmLogoutConfigs}
        />
      )}
    </StyledLogin>
  );
};

const routeLinks = routes
  .filter(({ navLink = false }) => navLink)
  .map(({ path, title }) => {
    return { path, title };
  });

export const Header = ({ auth }) => {
  const [opened, setOpened] = useState(false);
  const toggleOpened = () => setOpened(!opened);

  const handleClick = () => {
    opened && toggleOpened();
  };

  return (
    <StyledHeaderWrapper>
      <StyledHeaderLine>
        <Container>
          <StyledHeaderNav>
            <Link to={auth ? CONSOLE_PROFILE : MAIN}>
              <picture className="card__photo">
                <source srcSet={logoWEBP} type="image/webp" />
                <source srcSet={logo} type="image/png" />
                <StyledLogo src={logo} alt="logo" />
              </picture>
            </Link>
            <StyledContactsWrapper>
              <Socials className="socials--desktop" />
              <StyledSocialLink href="tel:+37068121500">
                <TelIcon className="icon icon--dark" />
                <span>+370 681 21 500</span>
              </StyledSocialLink>
            </StyledContactsWrapper>
          </StyledHeaderNav>
        </Container>
      </StyledHeaderLine>
      <StyledHeaderLine>
        <Container>
          <StyledHeaderNav>
            <Socials className="socials--mobile" />
            <StyledHeaderNavRow className={opened ? 'opened' : ''}>
              <StyledHeaderNavLinksWrapper>
                <StyledHeaderNavLinks>
                  {routeLinks.map(({ path, title }, i) => (
                    <li key={i}>
                      <StyledHeaderLink
                        to={path}
                        onClick={handleClick}
                        activeClassName="active"
                      >
                        <span>{title}</span>
                      </StyledHeaderLink>
                    </li>
                  ))}
                </StyledHeaderNavLinks>
              </StyledHeaderNavLinksWrapper>
              <Login loginState={auth} handleCloseBurger={handleClick} />
            </StyledHeaderNavRow>
            <StyledBurger
              onClick={toggleOpened}
              className={opened ? 'opened' : ''}
            >
              <StyledBurgerStick />
              <StyledBurgerStick />
            </StyledBurger>
          </StyledHeaderNav>
        </Container>
      </StyledHeaderLine>
    </StyledHeaderWrapper>
  );
};
